import { correctAscendancy, ancestryToList, parseYear } from '../family-search/actions';
import { batchUpdateCells, clearAllCellsData } from '../cells'

import { find, forEach } from 'lodash';

export function importGEDCOMPerson(person, persons, links) {
  return dispatch => {
    linkParents(person, persons, links);
    person.ascendancy = 1;
    correctAscendancy(person);
    const list = [];
    ancestryToList(person, list);

    dispatch(clearAllCellsData());
    dispatch(batchUpdateCells(list));
  }
}


export function parseGEDCOMPerson(person) {
  forEach({birth: 'BIRT', death: 'DEAT'}, (tag, type) => {
    const date = find(person.tree, t => t.tag === tag) || {};
    const year = find(date.tree, t => t.tag === 'DATE') || {};
    const yearStr = parseYear(year.data);
    if(yearStr) {
      person[type] = yearStr;
    }
  })
  return person;
}

function linkParents(person, persons, links) {
  const linkId = find(person.tree, t => t.tag === 'FAMC') || {};
  const link = find(links, l => l.id === linkId.data) || {};

  forEach({father: 'HUSB', mother: 'WIFE'}, (tag, type) => {
    const parentId = find(link.tree, t => t.tag === tag) || {};
    const parent = find(persons, p => p.id === parentId.data);
    if(parent) {
      person[type] = parent;
      linkParents(parent, persons, links);
    }
  })
}


// WEBPACK FOOTER //
// ./src/core/gedcom/actions.js